import {PivotRow, PivotColumn} from './PivotConfig';

export class MapKey {

  private _keyData = [];
  private _key = null;

  public static fromPivot(rows: PivotRow[], columns: PivotColumn[], data: any): MapKey {
    let _keyData = [];
    for (let row of rows) {
      let element = data[row.fieldName];
      if (element === undefined)
        element = null;
      _keyData.push(element);
    }
    for (let column of columns) {
      let element = data[column.fieldName];
      if (element === undefined)
        element = null;
      _keyData.push(element);
    }
    return new MapKey(_keyData);
  }

  public static fromArray(keyData: any[]): MapKey {
    return new MapKey(keyData);
  }

  private constructor(keyData: any[]) {
    for (let key of keyData)
      this._keyData.push(key);
  }

  toString(): string {
    if (this._key == null)
      this._key = JSON.stringify(this._keyData);
    return this._key;
  }

  getKeyData() {
    return Array.from(this._keyData);
  }

}
